import { Dayjs } from "dayjs"
import ParseError from "@/types/ParseError"
import { PrizeDrawEntryWinner } from "@/api/backofficeRest/generated/model"
import { DrawWinner } from "./drawWinner"
import { IDrawWinner } from "./drawWinner.types"

export const DrawWinnerParser = {
  // lastWonDate is derived across draws by the service, so it is injected here.
  toDomain: (
    data: PrizeDrawEntryWinner,
    lastWonDate: Dayjs | null = null,
  ): IDrawWinner => {
    try {
      return new DrawWinner(
        String(data.id),
        String(data.billingAccountId),
        data.accountNumber,
        data.prizeDrawRewardId?.toString() ?? null,
        data.surname,
        data.county,
        data.nameVisibilityOptOut,
        data.status,
        data.rewardProcessError ?? null,
        lastWonDate,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
